import { createFileRoute } from '@tanstack/react-router';

import { sideline } from '@/api/sideline';
import { SidelinePage } from '@/components/sideline/SidelinePage';

function Page() {
  return <SidelinePage api={sideline} sport="soccer" />;
}

export const Route = createFileRoute('/custom/sideline')({
  component: Page
});
